import { mountBrightcovePosterPlayer } from './shared-brightcove-embed';

export function mount(root: HTMLElement): void {
  root.querySelectorAll<HTMLElement>('[data-media-content-block-player]').forEach(player => {
    mountBrightcovePosterPlayer(player, {
      frameClassName: 'media-content-block__video-frame',
      playButtonSelector: '[data-media-content-block-play]'
    });
  });
}
